// extracted by mini-css-extract-plugin
export var swtch_btn = "undrtoggle-module--swtch_btn--3d59c";
export var swtch_btns = "undrtoggle-module--swtch_btns--0f5a7";
export var swtch_label = "undrtoggle-module--swtch_label--8d542";